import { RouterStore } from 'mobx-react-router';

export default new RouterStore();


// WEBPACK FOOTER //
// ./src/stores/routingStore.js